<div
  class="bg-black text-white rounded p-2 wm-6"
  data-test-selector="category-tooltip"
>
  <div
    class="category-tooltip"
    *ngFor="let category of categories; let i = index"
  >
    <div [style.padding-left.px]="i * 5">
      <i class="fa fa-folder me-1"></i> {{ category.name }}
    </div>
  </div>
</div>
